import MD5 from 'crypto-js/md5';
import axios from 'axios';
import defaultProfileLogo from '@/assets/navigation/demo-profile.png';

export default async function generateGravatar(
    email = '',
    name = '',
    initialAvatarBackground = '757575',
    initialColor = 'fff',
    initialSize = '50',
) {
    const processedName = name.toString().replace(/( )+/g, '+');
    const defaultImageUrl = encodeURIComponent(
        `https://ui-avatars.com/api/${processedName}/${initialSize}/${initialAvatarBackground}/${initialColor}`,
    );
    const processedEmail = email.toString().trim().toLowerCase();
    const hash = email ? MD5(processedEmail).toString() : '';

    const gravatarUrl = `https://www.gravatar.com/avatar/${hash}?d=404&s=${initialSize}`;

    try {
        const response = await axios.head(gravatarUrl);
        if (response.status === 200) {
            return gravatarUrl; // Gravatar exists
        }
    } catch (error) {
        if (processedName) {
            return `https://www.gravatar.com/avatar/${hash}?d=${defaultImageUrl}&s=${initialSize}`;
        } else {
            return defaultProfileLogo;
        }
    }
}
